import React from "react";

const getYearIdFromUrl = () => {
  if (typeof window === "undefined") return null;
  try {
    const params = new URLSearchParams(window.location.search || "");
    const raw = params.get("yearId");
    const parsed = Number(raw);
    return Number.isFinite(parsed) ? parsed : null;
  } catch {
    return null;
  }
};

export const getUniformOptionWidthClass = (options = []) => {
  const longestOptionLength = options.reduce((maxLength, option) => {
    if (typeof option !== "string") {
      return maxLength;
    }

    return Math.max(maxLength, option.replaceAll("_", ",").length);
  }, 0);

  if (longestOptionLength > 40) {
    return "max-w-[28rem] sm:max-w-[32rem]";
  }

  if (longestOptionLength > 28) {
    return "max-w-[22rem] sm:max-w-[24rem]";
  }

  if (longestOptionLength > 18) {
    return "max-w-[17rem] sm:max-w-[19rem]";
  }

  return "max-w-[14rem]";
};

const CustomOptionButton = ({
  text,
  index,
  selectedIdx,
  onClick,
  fontSize,
  optionWidthClass,
}) => {
  const normalizedText =
    typeof text === "string" ? text.replaceAll("_", ",") : "";
  const isLink =
    typeof text === "string" &&
    (text.startsWith("https://") || text.startsWith("http://"));
  const yearId = getYearIdFromUrl();

  const isUpToYear3 = yearId !== null && yearId <= 4;
  const isNumericOnly = /^[0-9]+$/.test(normalizedText.trim());

  const isSelected = Array.isArray(selectedIdx)
    ? selectedIdx.includes(index)
    : selectedIdx === index;

  const widthClasses = isLink
    ? "max-w-[8rem] sm:max-w-[10rem] md:max-w-[12rem]"
    : optionWidthClass || "max-w-[14rem]";
  const baseClasses =
    "flex min-h-[4rem] h-auto w-full items-center justify-center overflow-hidden rounded-3xl transition-all duration-300 cursor-pointer font-mali font-bold sm:min-h-[4.25rem]";

  // ✅ Handle fontSize prop or fall back to dynamic text size based on length
  const getTextSizeStyle = () => {
    if (fontSize && normalizedText.length <= 15) {
      return { fontSize: fontSize };
    }
    return {};
  };

  const getTextSizeClasses = () => {
    if (fontSize && normalizedText.length <= 15) {
      return "";
    }
    if (normalizedText.length > 40) {
      return "text-xs sm:text-sm md:text-base";
    }
    return normalizedText.length > 19
      ? "text-sm sm:text-base md:text-lg"
      : "text-lg sm:text-xl md:text-2xl";
  };

  const stateClasses = isSelected
    ? "bg-blue-300 text-white"
    : "hover:bg-blue-100 bg-gray-100";
  const textClasses = `${getTextSizeClasses()} w-full text-center leading-tight`;

  const imageClasses =
    "max-h-10 max-w-full object-contain sm:max-h-12 md:max-h-16";

  let optionContent = null;

  if (isLink) {
    optionContent = isUpToYear3 ? (
      <div
        key={index}
        onClick={() => onClick(index)}
        className={`custom-option-button relative w-[60px] h-[60px] sm:w-[84px] sm:h-[84px] md:w-[100px] md:h-[100px] flex items-center justify-center cursor-pointer transition-transform duration-300 ${
          isSelected ? "md:scale-110" : "md:hover:scale-105"
        } active:scale-95`}
      >
        {/* Wrapper sized exactly to the image */}
        <div className="relative inline-flex items-center justify-center">
          <img
            alt="option"
            src={text}
            className={`custom-option-button-image ${imageClasses}`}
          />
          {isSelected && (
            <div className="absolute inset-0 bg-blue-500 opacity-50 rounded-full" />
          )}
        </div>
      </div>
    ) : (
      <div
        key={index}
        onClick={() => onClick(index)}
        className={`custom-option-button ${baseClasses} px-4 py-2 ${stateClasses}`}
      >
        <img
          alt="option"
          src={text}
          className={`custom-option-button-image ${imageClasses}`}
        />
      </div>
    );
  } else if (isUpToYear3 && isNumericOnly) {
    optionContent = (
      <div
        key={index}
        onClick={() => onClick(index)}
        className={`custom-option-button w-[60px] h-[60px] sm:w-[84px] sm:h-[84px] md:w-[100px] md:h-[100px] rounded-full flex items-center justify-center font-mali font-bold shadow-md cursor-pointer transition-transform duration-300 active:scale-95 ${
          isSelected
            ? "bg-blue-300 text-white"
            : "bg-white text-black hover:scale-105"
          }`}
        title={normalizedText}
      >
        <span className={`custom-option-button-text ${getTextSizeClasses()}`}>
          {normalizedText}
        </span>
      </div>
    );
  } else {
    optionContent = (
      <div
        key={index}
        onClick={() => onClick(index)}
        className={`custom-option-button ${baseClasses} px-4 py-2 ${textClasses} ${stateClasses}`}
        style={getTextSizeStyle()}
        title={normalizedText}
      >
        <span className="custom-option-button-text block w-full">
          {normalizedText}
        </span>
      </div>
    );
  }

  return (
    <div
      className={`custom-option-button-wrap flex min-w-0 shrink-0 justify-center ${widthClasses}`}
    >
      {optionContent}
    </div>
  );
};
export default CustomOptionButton;
